export default __webpack_public_path__ + "static/media/stability.00e7bd58.svg";